import React from "react";
import "../App.css";
import "../sections/Experience.css";
import experiences from "../data/experience.json";

const Experience = () => (
  <section id="experience" className="experience-section">
        <h1 id="experience-header">Experience</h1>

   {experiences.map((exp, index) => (
        <div className="experience-card" key={index}>
          <span className="date">{exp.date}</span>
          <p className="company">{exp.company}</p>
          <h3 className="role">{exp.role}</h3>
          <p className="description">{exp.description}</p>
          <div className="tags">
            {exp.tags.map((tag, i) => (
              <span className="tag" key={i}>{tag}</span>
            ))}
          </div>
        </div>
      ))}
  </section>
);

export default Experience;
